module.exports = __webpack_public_path__ + "img/img3.937c3988.png";